import React, { useEffect } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import PageHeader from '../components/PageHeader';
import CountriesPage from '../components/CountriesPage';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import SEO from '../components/SEO';

const PageContainer = styled.div`
  background-color: #ededed;
  min-height: 100vh;
`;

const Countries = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <SEO 
        title="Страны для отдыха | Максимум Тур - Путешествия по всему миру"
        description="Все страны для отдыха от турагентства Максимум Тур. Таиланд, Вьетнам, Китай, Индия и другие направления. Подбор туров в любую страну мира."
        keywords="страны для отдыха, направления, куда поехать, отдых за границей, путешествия, туры по миру, Максимум Тур"
        type="website"
      />
      <Menu />
      <Header />
      <PageHeader />
      <CountriesPage />
      <ContactForm />
      <Footer />
    </PageContainer>
  );
};

export default Countries;